import React, { useEffect, useState } from 'react';
import { GithubRepoDemo } from '../../../../../data';
import { UserCardV3 } from '../../../../features/User/UserCard';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import Button from '../../../../utils/Button';
import { GetDateFromISO } from '../../../../utils/Show';
import cn from '../../../../utils/cn';
import {
    handleGetGithubRepoListOpe,
    handleLinkGithubRepoWithAppOpe
} from '../SubscriptionsDetailsOpe';
import { useSubscriptionsDetails } from '../SubscriptionsDetailsProvider';

function GitRepoTr({ item, subscriptionId }) {
    const { setMessage, setConfirm, setTemplateLoading } = useTemplate();
    // const [loading, setLoading] = useState(false);
    const { setOpenLinkWithGithubModal, setReloadKey } = useSubscriptionsDetails();
    // Confirm Modal open
    const handleLinkThisRepo = (data) => {
        setConfirm({
            text: 'Are you sure you want to link-up repository in this app?',
            textAction: 'Yes',
            clickAction: () => {
                setTemplateLoading(true);
                handleLinkGithubRepoWithAppOpe(subscriptionId, data?.fullName)
                    .then(({ title }) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        setReloadKey((prev) => prev + 1);
                        setOpenLinkWithGithubModal((d) => ({ ...d, show: false }));
                    })
                    .catch((error) => {
                        setTemplateLoading(false);
                        setMessage({ type: 'error', text: error.toString(0) });
                    });
            }
        });
    };

    return (
        <tr
            className={cn('hover:!bg-secondary-50', {
                'placeholder-mode': item?.demo
            })}
        >
            <td className="!pl-5">
                <span>
                    <UserCardV3
                        icon={item?.owner?.avatarUrl}
                        title={item?.name}
                        subTitle={item?.fullName}
                    />
                </span>
            </td>
            <td className="text-center">
                <span>{GetDateFromISO(item?.createdAt)}</span>
            </td>
            <td className="text-center">
                <span>{GetDateFromISO(item?.updatedAt)}</span>
            </td>
            <td className="text-center ">
                <span>
                    <Button
                        title="Link"
                        onClick={() => handleLinkThisRepo(item)}
                        className="md:min-w-min md:h-7.5 md:py-[3px] px-[15px] bg-secondary-100 hover:bg-secondary text-secondary hover:text-white font-medium rounded-md transition text-sm border border-secondary-100"
                    />
                </span>
            </td>
        </tr>
    );
}
function TableHeader() {
    return (
        <thead>
            <tr className="text-primary cursor-default">
                <th scope="col" className="!w-auto">
                    Repository Details
                </th>
                <th scope="col" className="w-30 text-center">
                    Created At
                </th>
                <th scope="col" className="w-30 text-center">
                    Update At
                </th>
                <th scope="col" className="!w-30">
                    #
                </th>
            </tr>
        </thead>
    );
}

function AddGithubLinkUpModal({ subscriptionId, openLinkWithGithubModal }) {
    const { setMessage } = useTemplate();
    const [repoList, setRepoList] = useState(GithubRepoDemo);
    // Get Github Repo List
    useEffect(() => {
        handleGetGithubRepoListOpe(subscriptionId)
            .then(({ data }) => {
                setRepoList(data);
            })
            .catch((error) => {
                setRepoList([]);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    }, [subscriptionId, setMessage]);
    // Filter Repo List using full name and search input
    const newRepoList = repoList?.filter((item) =>
        item?.fullName?.toLowerCase()?.includes(openLinkWithGithubModal?.Search?.toLowerCase())
    );
    return (
        <div className="w-full min-h-60">
            <table className="bik-table">
                <TableHeader />
                <tbody>
                    {newRepoList && newRepoList?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={4} className="!text-left">
                                No Invoice Found!
                            </td>
                        </tr>
                    ) : (
                        newRepoList?.map((item) => (
                            <GitRepoTr key={item?.id} item={item} subscriptionId={subscriptionId} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default AddGithubLinkUpModal;
